import axios from "axios";
import { baseUrlRobofin, xApiKeyRobofin } from "../../config/api/apiConfig";

const apiBankTempUrl = "https://43lvjrbbtj.execute-api.ap-southeast-1.amazonaws.com";
const apiOrgTempYrl = "https://xuabd2o14c.execute-api.ap-southeast-1.amazonaws.com";

class OrganizationApiService {
  private axios = axios.create({
    baseURL: baseUrlRobofin,
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async getPoplarBank() {
    try {
      return await this.axios.get<any>(`${apiBankTempUrl}/util/id/get-bank-list`, {});
    } catch (e: any) {
      throw new Error(e);
    }
  }

  public async getOrganizations(params?: any) {
    // const queries = {
    //     ...(params?.dealerCode && {
    //         dealer_code: params.dealerCode,
    //     }),
    // }
    try {
      return await this.axios.get<any>(`${apiOrgTempYrl}/dev/orgs`, {
        headers: {
          "X-Api-Key": xApiKeyRobofin,
        },
        // params: {
        //     ...queries,
        // }
      });
    } catch (e: any) {
      throw new Error(e);
    }
  }

  public async getBusinessEntities(params?: any) {
    try {
      return await this.axios.get<any>(`${apiOrgTempYrl}/dev/orgs/npwp`, {
        headers: {
          "X-Api-Key": "HbP2C6A0Ao7uHYRABXnBI4MEGkCBIijwmnK7J195",
        },
        params: params,
      });
    } catch (e: any) {
      //   console.log("aaaa");

      throw new Error(e.response.data.message);
    }
  }

  public async getDeposit(data?: any) {
    try {
      console.log(data);

      return await this.axios.post<any>("/cash/deposit/show", data);
    } catch (e: any) {
      //   console.log("aaaa");

      throw new Error(e.response.data.message);
    }
  }
}

export const organizationApiService = new OrganizationApiService();
